import ButtonBase from "@material-ui/core/ButtonBase";

import Link from "next-translate/Link";
import useTranslation from "next-translate/useTranslation";
import React from "react";

import Props from "@sentrei/common/types/components/Logo";

import LogoStyles from "./LogoStyles";

export default function Logo({logo, root = true}: Props): JSX.Element {
  const classes = LogoStyles();
  const {lang} = useTranslation();

  return (
    <Link href={root ? "/" : "/dashboard"} lang={lang}>
      <ButtonBase className={classes.logo}>{logo}</ButtonBase>
    </Link>
  );
}
